import { Component, Output , EventEmitter, OnInit } from '@angular/core';
import { FileDetails } from '../shared/models/file-details.model';
import { GlobalsService } from '../shared/services/globals.service';
const $ = require('jquery');

@Component({
  selector: 'acr-file-upload-loader',
  template: `<input id="xmlFileUpload" class="hidden" type="file" accept=".xml" (change)="changeListener($event)" (click)="hideMessage()">
<label for="xmlFileUpload" class="btn btn-success bg-olive margin-10" title="Choose a Module">Choose a Module</label>
<br>
<div id="xmlOnlyMsg" class="error-msg"> Only XML files are supported !!!</div>
`,
  styles: [``]
})

export class FileUploadLoaderComponent implements OnInit  {
  @Output() onFileContentRead: EventEmitter<FileDetails> = new EventEmitter<FileDetails>();
  fileReader: FileReader = new FileReader();
  readFile: File;
constructor (private configService: GlobalsService) {

}
  ngOnInit(): void {
    this.hideMessage();
    this.showTestModule();
    setTimeout(() => {
      this.showDefaultModule();
      }, 100);
  }

  changeListener($event): void {
    let fileName: string;
    fileName = $event.target.value;
    if (fileName.includes('.xml') || fileName.includes('.Xml') || fileName.includes('.XML') ||
    fileName.includes('.zip') || fileName.includes('.Zip') || fileName.includes('.ZIP')) {
      this.hideMessage();
    this.readThis($event.target);
    } else {
      if (fileName !== '' && fileName !== undefined) {
        $('#xmlOnlyMsg').show();
      }
    }
  }

  hideMessage() {
    $('#xmlOnlyMsg').hide();
  }

  readThis(inputValue: any): void {
    this.readFile = inputValue.files[0];
    const self = this;
    const extensionStartPosition = self.readFile.name.lastIndexOf('.');
    this.fileReader.onloadend = (e) => {
      self.onFileContentRead.emit( new FileDetails(self.readFile.name.substring(0, extensionStartPosition),    self.readFile.name, this.fileReader.result));
    };
    this.fileReader.readAsText(this.readFile);
  }

  showDefaultModule() {
    this.configService.getDefaultModulePath()
      .subscribe(data => {
        const self = this;
        self.onFileContentRead.emit( new FileDetails('Hello Assist 2.0', 'Hello_Assist.xml', data));
      });
  }

  showTestModule() {
    this.configService.getDefaultTestModulePath()
    .subscribe(data => {
      const self = this;
      self.onFileContentRead.emit( new FileDetails('Test Module', 'Test_Module.xml', data));
    });
  }
}
